import React from "react"
import './CreateApiKey.css'
import {IconButton, InputAdornment, TextField} from "@mui/material";
import ContentCopySharpIcon from '@mui/icons-material/ContentCopySharp';
import {SnackbarMode, useGlobalSnackbar} from "../Snackbar/useGlobalSnackbar";

type Props = {
    handleClose: () => void
    apiKey: string
}

const ShowCreatedApiKey: React.FC<Props> = ({handleClose, apiKey}) => {

    const {showSnackbar} = useGlobalSnackbar();


    const copyToClipboard = () => {
        navigator.clipboard.writeText(apiKey).then(() => showSnackbar("Copied", SnackbarMode.SUCCESS))
    }

    return(
        <React.Fragment>
            <div className="showKeyWrapper" style={{width: '100%'}}>
                <TextField
                    value={apiKey}
                    fullWidth
                    disabled
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={copyToClipboard}>
                                    <ContentCopySharpIcon />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </div>
            <div style={{display: 'flex', justifyContent: 'end', marginTop: '10px', gap: 10}}>
                <button onClick={handleClose} className="button button--primary" >Close</button>
            </div>
        </React.Fragment>
    )
}

export {ShowCreatedApiKey}